var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavLabels = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.849 4.57v4.912c0 .344.137.675.38.919l6.95 6.95a1.299 1.299 0 0 0 1.84 0l4.91-4.912a1.3 1.3 0 0 0 0-1.838l-6.95-6.95a1.3 1.3 0 0 0-.918-.381H4.149a1.3 1.3 0 0 0-1.3 1.3Zm4.5 4.7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
})));
SvgNavLabels.displayName = "SvgNavLabels";
export { SvgNavLabels as ReactComponent };
export default SvgNavLabels;